//imports
import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import AppBar from "@mui/material/AppBar";
import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import BorderColorOutlinedIcon from "@mui/icons-material/BorderColorOutlined";
import Navbar from "../../components/common/Navbar";
import { useStyles } from "../../assets/styles/Theme";
import ViewData from "../../components/grids/ViewDatagrid";
import { pcatergorydata } from "../../assets/Griddata";
import { externalgetApi } from "../../services/external/externalApis";
import SearchAppBar from "../../components/common/search";
import { useSelector } from "react-redux";
import {
  SETTINGS_API_02,
  SETTINGS_API_17,
  MENUTYPECODE,
  STS,
} from "../../api/ApiModel";

function ViewSetupMenucategory() {
  //----------------------hooks------------------
  const navigate = useNavigate();
  const theme = useTheme();
  const styles = useStyles(theme);

  const [data, setData] = useState(null);
  const [filteredRows, setFilteredRows] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [searchText, setSearchText] = useState("");
  const [isAddDisabled, setIsAddDisabled] = useState(false); // Track Add button state
  const SYS_USER = useSelector((state) => state.user) || {};
  const { COMPCODE, LOCCODE, RESTCODE } = SYS_USER.USER_PARAM || {};

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await externalgetApi(SETTINGS_API_17, "get", {
          COMPCODE,
          LOCCODE,
          RESTCODE,
        });
        setData(result);
        setFilteredRows(result);

        // Disable the Add button if the length of result is 1 or more
        if (result.length >= 1) {
          setIsAddDisabled(true);
        } else {
          setIsAddDisabled(false);
        }
      } catch (err) {
        console.error("Error fetching data:", err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [COMPCODE, LOCCODE, RESTCODE]);

  useEffect(() => {
    if (data) {
      const filtered = data.filter(
        (item) =>
          item.MENUCATNAME.toLowerCase().includes(searchText.toLowerCase()) ||
          item.MENUCATCODE.toString()
            .toLowerCase()
            .includes(searchText.toLowerCase())
      );
      setFilteredRows(filtered);
    }
  }, [searchText, data]);

  //----------------functions--------------------

  const handleSearchChange = (event) => {
    setSearchText(event.target.value);
  };

  const gotToPage = () => {
    navigate("/PromotionMenu");
    setIsAddDisabled(true); // Disable the button after navigation
  };

  const handleItemClick = (id, actionText) => {
    if (actionText === "Edit") {
      const selectedItem = data.find((item) => item.MENUCATCODE === id);
      if (selectedItem) {
        navigate(`/PromotionMenu`, { state: { selectedItem, actionText } });
      }
    }
  };

  const menuItems = [
    {
      text: "Edit",
      icon: <BorderColorOutlinedIcon />,
      onClick: (MENUCATCODE) => handleItemClick(MENUCATCODE, "Edit"),
    },
  ];

  return (
    <div>
      <Navbar />
      <AppBar sx={styles.AI_CustomAppBar1}>
        <Box sx={styles.AI_HeaderContainer1}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Breadcrumbs
                sx={styles.AI_breadcrumbs2}
                separator={<NavigateNextIcon fontSize="small" />}
              >
                <Link underline="none">Home</Link>
                <Link underline="none">Promotions</Link>
                <Link underline="none">View Promotion Category</Link>
              </Breadcrumbs>
            </Grid>
            <Grid item xs={12} md={6} p={2}>
              <Stack
                sx={styles.AI_fixedStack1}
                direction="row"
                justifyContent="flex-end"
                spacing={2}
                padding={1}
                ml={1}
              >
                {!isAddDisabled && ( // Render Add button only if not disabled
                  <Button
                    onClick={gotToPage}
                    variant="contained"
                    size="medium"
                    startIcon={<AddCircleIcon />}
                    sx={{
                      background: theme.palette.primary.main,
                      color: theme.palette.text.buttontxt,
                      textTransform: "capitalize",
                      letterSpacing: "2px",
                      width: "80px",
                    }}
                    disabled={isAddDisabled} // Disable button when clicked
                  >
                    Add
                  </Button>
                )}
              </Stack>
            </Grid>
          </Grid>
        </Box>
      </AppBar>

      {isLoading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "60vh",
          }}
        >
          <CircularProgress color="primary" />
        </Box>
      ) : (
        <ViewData
          columns={pcatergorydata.columns}
          rows={filteredRows.map((item) => ({ ...item, id: item.MENUCATCODE }))}
          menuItems={menuItems}
          tabletitle={pcatergorydata.name}
          gridid="MENUCATCODE"
        />
      )}
    </div>
  );
}

export default ViewSetupMenucategory;
